import { Helmet } from "react-helmet-async"
import { ReactComponent as IconArrowLeft } from "../../../../assets/img/workshops/arrow-left.svg"
import { ReactComponent as IconCheck } from "../../../../assets/img/workshops/checkmark.svg"
import { ReactComponent as IconChevronDown } from "../../../../assets/img/workshops/chevron-down.svg"
import { ReactComponent as IconDevices } from "../../../../assets/img/workshops/devices.svg"
import { ReactComponent as IconFile } from "../../../../assets/img/workshops/file.svg"
import { ReactComponent as IconOnline } from "../../../../assets/img/workshops/online.svg"
import { ReactComponent as IconWifi } from "../../../../assets/img/workshops/wifi.svg"

import ImageDunia from "../../../../assets/img/workshops/image-dunia.png"
import ImageRaquel from "../../../../assets/img/workshops/image-raquel.png"
import { Link } from "react-router-dom"

import "./detail.css"

const EmotionalEatingPage = () => {
  return (
    <>
      <Helmet>
        <link
          rel="canonical"
          href={`${process.env.REACT_APP_FRONT_URL}/productos/taller-alimentacion-y-emociones`}
        />
        <title>Taller Relación con la Comida | Come desde el autocuidado</title>
        <meta
          name="description"
          content="Transforma tu relación con la comida y contigo mismo. Aprende a comer sin culpa, desde la calma y el autocuidado con los expertos de Vikika Team."
        />
        <meta
          name="keywords"
          content="relación con la comida, comer saludable, hambre emocional, autocuidado, alimentación consciente, nutrición, bienestar mental, Vikika Team"
        />
        <meta
          property="og:title"
          content="Taller Relación con la Comida | Come desde el autocuidado"
        />
        <meta
          property="og:description"
          content="Transforma tu relación con la comida y contigo mismo. Aprende a comer sin culpa, desde la calma y el autocuidado con los expertos de Vikika Team."
        />
        <meta
          property="og:url"
          content={`${process.env.REACT_APP_FRONT_URL}/productos/taller-alimentacion-y-emociones`}
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content={`${process.env.REACT_APP_FRONT_URL}/img/workshops/nutricion.png`}
        />
      </Helmet>

      <main className="main-content">
        <div className="workshops-page">
          <header
            className="workshops-detail-hero"
            style={{ backgroundColor: "var(--accent-2-main)" }}
          >
            <div className="workshops-detail-hero-content">
              <div className="workshops-chip">
                <IconOnline />
                <p>Online</p>
              </div>
              <h1 className="workshops-detail-hero-title">
                ¿Comes mal porque estás mal o estás mal porque comes mal?
              </h1>
              <p className="workshops-detail-hero-description">
                En este taller descubrirás cómo transformar tu relación con la comida y contigo
                mismo. Aprenderás a identificar los verdaderos motivos detrás de tus elecciones
                alimentarias y a disfrutar de una alimentación consciente y equilibrada. Con
                herramientas prácticas y objetivos claros, te guiaremos hacia un cambio real y
                sostenible.
              </p>
              <div className="workshops-detail-hero-footer">
                <div className="workshops-detail-hero-info">
                  <div className="workshops-detail-hero-info-data">
                    <p className="label">Duración</p>
                    <p className="value">1h 30min</p>
                  </div>
                  <div className="workshops-detail-hero-info-data">
                    <p className="label">Impartido por</p>
                    <p className="value">Raquel y Dunia</p>
                  </div>
                  <div className="workshops-detail-hero-info-data">
                    <p className="label">Precio</p>
                    <p className="value">29,99€</p>
                  </div>
                </div>
                <a
                  href="https://vikika-team-s-school.teachable.com/l/pdp/comes-porque-estas-mal-o-estas-mal-porque-comes"
                  className="workshops-btn workshops-btn-green"
                >
                  Me apunto <IconArrowLeft className="workshops-btn-icon" />
                </a>
              </div>
            </div>
          </header>
          {/* Guía */}
          <section className="workshops-section workshops-guide">
            <h2 className="workshops-section-title">¿Qué aprenderás?</h2>
            <div className="workshops-guide-content">
              <details className="workshops-guide-step" name="guide-steps">
                <summary className="workshops-guide-step-launcher">
                  <span className="workshops-guide-number">1</span>
                  Reconecta contigo mismo
                  <IconChevronDown />
                </summary>
                <p>
                  Descubre cómo tu relación contigo condiciona tu manera de comer y aprende a
                  construir un vínculo saludable que se refleje en todos los aspectos de tu vida.
                </p>
              </details>
              <details className="workshops-guide-step" name="guide-steps">
                <summary className="workshops-guide-step-launcher">
                  <span className="workshops-guide-number">2</span>
                  Conoce tu relación con la comida
                  <IconChevronDown />
                </summary>
                <p>
                  Identifica si comes por hambre real o hambre emocional y aprende a tomar
                  decisiones alimentarias libres y conscientes.
                </p>
              </details>
              <details className="workshops-guide-step" name="guide-steps">
                <summary className="workshops-guide-step-launcher">
                  <span className="workshops-guide-number">3</span>
                  Convierte tu autoexigencia en tu aliada
                  <IconChevronDown />
                </summary>
                <p>
                  Deja de castigarte y empieza a usar tu autoexigencia como motor de superación
                  personal, sin culpa ni comparaciones.
                </p>
              </details>
              <details className="workshops-guide-step" name="guide-steps">
                <summary className="workshops-guide-step-launcher">
                  <span className="workshops-guide-number">4</span>
                  Vive la experiencia de la alimentación consciente
                  <IconChevronDown />
                </summary>
                <p>
                  Aprende a comer disfrutando con los cinco sentidos, liberándote de distracciones y
                  recuperando el placer de cada bocado.
                </p>
              </details>
              <details className="workshops-guide-step" name="guide-steps">
                <summary className="workshops-guide-step-launcher">
                  <span className="workshops-guide-number">5</span>
                  Consigue resultados con objetivos SMART
                  <IconChevronDown />
                </summary>
                <p>
                  Diseña metas claras, medibles y realistas que te motiven y te mantengan en el
                  camino correcto.
                </p>
              </details>
              <details className="workshops-guide-step" name="guide-steps">
                <summary className="workshops-guide-step-launcher">
                  <span className="workshops-guide-number">6</span>
                  Rompe con el miedo y las creencias limitantes
                  <IconChevronDown />
                </summary>
                <p>
                  Libérate de ideas aprendidas que frenan tu progreso y recupera la confianza en tu
                  capacidad para cambiar.
                </p>
              </details>
              <details className="workshops-guide-step" name="guide-steps">
                <summary className="workshops-guide-step-launcher">
                  <span className="workshops-guide-number">7</span>
                  Descubre qué tipo de comedor eres
                  <IconChevronDown />
                </summary>
                <p>
                  Comprende tus patrones de conducta para personalizar tu camino hacia una
                  alimentación equilibrada y sin culpa.
                </p>
              </details>
              <details className="workshops-guide-step" name="guide-steps">
                <summary className="workshops-guide-step-launcher">
                  <span className="workshops-guide-number">8</span>
                  Disfruta el proceso de cambio
                  <IconChevronDown />
                </summary>
                <p>
                  Transforma tu forma de comer sin sufrimiento, viviendo el cambio como una
                  experiencia positiva y motivadora.
                </p>
              </details>
            </div>
          </section>
          {/* Para ti */}
          <section className="workshops-section workshops-for-you">
            <h2 className="workshops-section-title">Estos talleres son para ti si…</h2>

            <div className="workshops-grid">
              <div className="workshops-card-simple">
                <IconCheck />
                <p>
                  <strong>Quieres disfrutar</strong> más de la comida{" "}
                  <strong>sin culpa y sentirte bien</strong> contigo mismo.
                </p>
              </div>
              <div className="workshops-card-simple">
                <IconCheck />
                <p>
                  <strong>Te apetece aprender a escuchar tu cuerpo,</strong> diferenciar el hambre
                  real de la emocional y tomar decisiones que te hagan sentir en equilibrio.
                </p>
              </div>
              <div className="workshops-card-simple">
                <IconCheck />
                <p>
                  <strong>Buscas herramientas prácticas</strong> para comer de forma consciente,
                  alcanzar tus objetivos de salud y bienestar, y disfrutar del proceso.
                </p>
              </div>
              <div className="workshops-card-simple">
                <IconCheck />
                <p>Ideal para quienes desean cuidarse con libertad, placer y motivación.</p>
              </div>
            </div>

            <div className="workshops-section-action">
              <a
                className="workshops-btn workshops-btn-primary"
                href="https://vikika-team-s-school.teachable.com/l/pdp/comes-porque-estas-mal-o-estas-mal-porque-comes"
              >
                Me apunto <IconArrowLeft className="workshops-btn-icon" />
              </a>
            </div>
          </section>
          {/* Necesito */}
          <section className="workshops-section workshops-requirements">
            <h2 className="workshops-section-title">¿Qué necesito?</h2>
            <div className="workshops-requirements-content">
              <div className="workshops-requirements-item">
                <IconDevices />
                <p>
                  <strong>Ordenador o dispositivo móvil</strong>
                </p>
              </div>
              <div className="workshops-requirements-item">
                <IconWifi />
                <p>
                  <strong>Conexión a internet</strong>
                </p>
              </div>
              <div className="workshops-requirements-item">
                <IconFile />
                <p>
                  <strong>Ordenador o Lápiz y papel</strong> o un dispositivo donde puedas apuntar
                  tus notas
                </p>
              </div>
            </div>
          </section>
          <section className="workshops-section workshops-experts">
            <h2 className="workshops-section-title">Nuestros profesionales</h2>
            <p className="workshops-section-description">
              Este curso está guiado por nutricionistas especializados en ayuno intermitente y salud
              hormonal, que combinan la evidencia científica con la experiencia práctica en
              consulta. Te acompañarán con un enfoque cercano, adaptado a ti y a tus necesidades,
              para que el ayuno sea una herramienta de bienestar y no una carga
            </p>
            <article className="workshops-experts-card">
              <img className="workshops-experts-card-image" src={ImageDunia} alt="Dunia Drexler" />
              <div className="workshops-experts-card-content">
                <h3 className="workshops-experts-card-title">Dunia Drexler</h3>
                <p className="workshops-experts-card-subtitle">
                  Graduada en Psicología por la Universidad Francisco de Vitoria y con Máster de
                  Psicología General Sanitaria en la Universidad San Pablo CEU.
                </p>
                <div className="workshops-experts-card-description">
                  <p>
                    Además, su continua formación la ha llevado a especializarse en inteligencia
                    emocional, terapia emocional sistémica con adultos, pareja y familia, así como
                    en violencia de género entre otros.
                  </p>
                  <p>
                    Su visión sobre la psicología y el ser humano es holística, por lo que le gusta
                    aplicar la corriente emocional sistémica en sus sesiones, ya que considera a la
                    persona dentro de un contexto y siempre teniendo en cuenta que la psicoterapia
                    debe adaptarse a las necesidades individuales.
                  </p>
                </div>
              </div>
            </article>
            <article className="workshops-experts-card">
              <img className="workshops-experts-card-image" src={ImageRaquel} alt="Raquel Capel" />
              <div className="workshops-experts-card-content">
                <h3 className="workshops-experts-card-title">Raquel Capel</h3>
                <p className="workshops-experts-card-subtitle">
                  Dietista-nutricionista colegiada y entrenadora personal certificada NSCA-CPT y con
                  Certificado AFDA0210.
                </p>
                <div className="workshops-experts-card-description">
                  <p>
                    Dietista-nutricionista colegiada y entrenadora personal certificada NSCA-CPT y
                    con Certificado AFDA0210. Su enfoque es integrador en salud, educación
                    alimentaria y coaching. Acumula una sólida experiencia clínica y deportiva
                    trabajando incluso con futbolistas profesionales, y una intensa labor
                    divulgativa en medios como ABC Bienestar, RNE, etc.
                  </p>
                  <p>
                    Comprometida con la formación continua, ha participado en congresos y cursos,
                    así como formaciones técnicas tanto en el ámbito de la nutrición como de
                    entrenamiento lo que le permite ofrecer un acompañamiento científico, empático y
                    actualizado para transformar la salud de las personas desde la raíz.
                  </p>
                  <p>
                    Su sello distintivo es una estrategia no pesocentrista, enfocada en la salud
                    real y sostenible.
                  </p>
                </div>
              </div>
            </article>
          </section>
          <section className="workshops-section workshops-faqs">
            <h2 className="workshops-section-title">¿Tienes dudas?</h2>
            <div className="workshops-faqs-content">
              <details className="workshops-faqs-item" name="faqs">
                <summary className="workshops-faqs-item-launcher">
                  ¿Necesito tener conocimientos previos para hacer el taller?
                  <IconChevronDown />
                </summary>
                <p>
                  No, está diseñado para cualquier persona interesada en mejorar su relación con la
                  comida, independientemente de su experiencia previa.
                </p>
              </details>
              <details className="workshops-faqs-item" name="faqs">
                <summary className="workshops-faqs-item-launcher">
                  ¿Puedo ver los videos cuando quiera?
                  <IconChevronDown />
                </summary>
                <p>
                  Si, podrás visualizar cada video y planificarte tus tiempos para hacer el taller
                  sin problema, ya que podrás acceder todas las veces y durante todo el tiempo que
                  quieras.
                </p>
              </details>
              <details className="workshops-faqs-item" name="faqs">
                <summary className="workshops-faqs-item-launcher">
                  ¿Es un taller teórico o práctico?
                  <IconChevronDown />
                </summary>
                <p>
                  Es una combinación de ambos: aprenderás conceptos clave y harás ejercicios y
                  dinámicas durante el taller.
                </p>
              </details>
              <details className="workshops-faqs-item" name="faqs">
                <summary className="workshops-faqs-item-launcher">
                  ¿Cuánto dura y en qué formato se imparte?
                  <IconChevronDown />
                </summary>
                <p>
                  Aproximadamente 1h 30min, en formato online. Podrás conectarte desde cualquier
                  lugar con tu ordenador o móvil y donde quieras.
                </p>
              </details>
              <details className="workshops-faqs-item" name="faqs">
                <summary className="workshops-faqs-item-launcher">
                  ¿Necesito algún material especial?
                  <IconChevronDown />
                </summary>
                <p>
                  Solo tu ordenador o móvil con conexión a internet y algo para apuntar lo que más
                  te inspire.
                </p>
              </details>
              <details className="workshops-faqs-item" name="faqs">
                <summary className="workshops-faqs-item-launcher">
                  ¿Quién imparte el taller y qué experiencia tienen?
                  <IconChevronDown />
                </summary>
                <p>
                  Dunia Drexler (psicóloga) y Raquel Capel (dietista-nutricionista y entrenadora),
                  ambas con amplia experiencia profesional y un enfoque integral en salud y
                  bienestar. llevan años ayudando a personas a mejorar su salud física y emocional.
                  Su enfoque es cercano, práctico y basado en ciencia.
                </p>
              </details>
              <details className="workshops-faqs-item" name="faqs">
                <summary className="workshops-faqs-item-launcher">
                  ¿Es adecuado si ya he hecho terapia o sigo un plan nutricional?
                  <IconChevronDown />
                </summary>
                <p>
                  Sí, es un complemento perfecto para integrar y reforzar lo que ya estés
                  trabajando. Este taller te dará herramientas extra para mantener la motivación y
                  disfrutar más del proceso.
                </p>
              </details>
            </div>
          </section>
          {/* Contacto */}
          <section className="workshops-section workshops-contact">
            <div className="workshops-contact-content">
              <h2 className="workshops-section-title">¿Necesitas un enfoque más personalizado?</h2>
              <p className="workshops-text">
                Si necesitas un acompañamiento más personalizado, podemos ayudarte. Nuestro equipo
                de psicólogos clínicos y nutricionistas está aquí para guiarte y trabajar contigo
                para que puedas gestionar mejor todas las situaciones de la vida.
              </p>
              <Link to="/contacto/" className="workshops-btn workshops-btn-primary">
                Contacta con nosotras
              </Link>
            </div>
          </section>
        </div>
      </main>
    </>
  )
}

export default EmotionalEatingPage
